<template>
  <a-row :gutter="20" class="dashboard">
    <a-col :span="isDesktop ? 16 : 24">
      <a-card :title="$t('cardTitle.howToSetupYourChurchProfile')" class="style1">
        <!-- <iframe src="https://player.vimeo.com/video/444367865" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe> -->

        <p v-text="$t('page.dashboardCare.howToSetupYourChurchProfile.para1')"></p>
        <br />
      </a-card>
      <a-card :title="$t('cardTitle.howToDirectChurchMembersToTruelifeCare')" class="style1">
        <!-- <iframe src="https://player.vimeo.com/video/444367865" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe> -->

        <p v-text="$t('page.dashboardCare.howToDirectChurchMembersToTruelifeCare.para1')"></p>

        <br />
        <br />
        <br />
      </a-card>
      <a-card :title="$t('cardTitle.whyYouShouldIncludeAPersonalVideoFromThePastor')" class="style1">
        <!-- <iframe src="https://player.vimeo.com/video/444367865" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe> -->

        <p v-text="$t('page.dashboardCare.whyYouShouldIncludeAPersonalVideoFromThePastor.para1')"></p>

        <br />
        <br />
        <br />
      </a-card>
      <a-card :title="$t('cardTitle.howToUseTruelifeCareInCounselingSessions')" class="style1">
        <!-- <iframe src="https://player.vimeo.com/video/444367865" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe> -->

        <p v-text="$t('page.dashboardCare.howToUseTruelifeCareInCounselingSessions.para1')"></p>

        <br />
        <br />
        <br />
      </a-card>
    </a-col>

    <a-col :span="isDesktop ? 8 : 24">
      <a-card :title="$t('cardTitle.accountPaymentDate')" v-if="nextPayment">
        <p>
          {{ $t('page.dashboard.accountPaymentDate.para1') }}:
          <strong>{{ nextPayment }}</strong>
        </p>
        <p>
          <a-button type="primary" @click="openLink('account')">
            <span> <a-icon type="user" />&nbsp;{{ $t('button.accountDetails') }} </span>
          </a-button>
        </p>
      </a-card>
      <a-card :title="$t('cardTitle.evangelismProgram')">
        <a-icon type="video-camera" />&nbsp;{{ $t('page.dashboardCare.evangelismProgram.para1') }}
        <br />
        <br />
        <a-button type="primary" @click="openLink('https://www.jointruelife.org/', true)">
          <span> <a-icon type="download" />&nbsp;{{ $t('button.learnMore') }} </span>
        </a-button>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import moment from 'moment';
import { mapState } from 'vuex';
import UserService from '@/services/UserService';
import { get } from 'lodash';
import { empty } from '@/utils';
export default {
  data: () => ({
    nextPayment: false,
  }),
  computed: {
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  methods: {
    openLink(url, isLink = false) {
      if (isLink) {
        window.location.href = url;
      } else {
        this.$router.push({ name: url });
      }
    },
  },
  async created() {
    const respInvoice = await UserService.getInvoices();
    const firstInvoiceDueOn = get(respInvoice, '[0].due_on');
    if (!empty(firstInvoiceDueOn)) {
      this.nextPayment = moment(firstInvoiceDueOn).add('years', 1).format('MM/DD');
    } else {
      this.nextPayment = false;
    }
  },
};
</script>
<style lang="scss">
.dashboard-container.content-page {
  padding: 0 !important;
  .dashboard {
    padding: 20px;
    .ant-btn {
      // height: 100%;
      white-space: initial;
    }
  }
}
</style>
